import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { getConsent, setConsent, initAnalytics } from "../../lib/analytics";

export const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = getConsent();
    if (!consent) setVisible(true);
    else if (consent === "all") initAnalytics();
  }, []);

  const choose = (value) => {
    setConsent(value);
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="cookie-consent-banner"
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 80, opacity: 0 }}
          transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-4 inset-x-4 sm:left-auto sm:right-6 sm:max-w-md z-[60] rounded-2xl border border-[#009BFF]/30 bg-[#041525]/95 backdrop-blur-md shadow-[0_20px_50px_rgba(2,10,18,0.6)] p-6"
        >
          <h3 className="text-sm font-extrabold text-white" style={{ fontFamily: "var(--font-heading)" }}>
            Cookies &amp; Privacy
          </h3>
          <p className="mt-2 text-xs text-[#B7C0CC] leading-relaxed">
            We use essential cookies to make this site work. With your consent, we also use
            analytics cookies to understand how the site is used. See our{" "}
            <Link to="/privacy" data-testid="cookie-privacy-link" className="text-[#00C4F4] underline underline-offset-2">
              Privacy Policy
            </Link>.
          </p>
          <div className="mt-4 flex flex-col sm:flex-row gap-3">
            <button
              data-testid="cookie-accept-all-btn"
              onClick={() => choose("all")}
              className="flex-1 rounded-lg bg-gradient-to-r from-[#006FD6] to-[#009BFF] text-white text-xs font-bold uppercase tracking-widest py-3 px-4 hover:brightness-110 transition-[filter] duration-300"
              style={{ fontFamily: "var(--font-heading)" }}
            >
              Accept All
            </button>
            <button
              data-testid="cookie-decline-btn"
              onClick={() => choose("essential")}
              className="flex-1 rounded-lg border border-white/20 text-[#B7C0CC] text-xs font-bold uppercase tracking-widest py-3 px-4 hover:border-[#009BFF]/50 hover:text-white transition-colors duration-300"
              style={{ fontFamily: "var(--font-heading)" }}
            >
              Decline Non-Essential
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
